import { IconButton } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { userData } from "schemas";
import { useRecoilValue } from "recoil";

export default function ChartDownloader({ reff, label, download }) {
    const user = useRecoilValue(userData)

    const handleDownload = () => {
        const chart = reff.current;

        if (!chart) return;

        const url = chart?.toBase64Image();

        const link = document.createElement('a');
        link.href = url;
        link.download = label + '.png';
        link.click();
    };

    return (
        <div style={{ display: "flex", justifyContent: "space-between" }} >
            <h6 style={{ marginTop: "20px" }} >{label}</h6>
            {(download && user?.acesso != '1') && <IconButton onClick={handleDownload} style={{ borderRadius: "0", marginTop: "10px" }} >
                <span style={{ fontSize: "15px", fontWeight: "500", cursor: "pointer", color: "#548C2F" }}  ><DownloadIcon />Download </span>
            </IconButton>}
        </div>
    )
}